<template>
  <div class="container1">
    <!-- 最上层的 tab 开始 -->
    <div class="tab-list">
      <ul class="tab-list">
        <li
          class="tab-1"
          :class="getTabListClass(index)"
          v-for="(item, index) in tabList"
          :key="index"
          @click="tabChange(index, item.name)"
          @mouseover="tabMouseOver(index)"
          @mouseout="tabMouseOut()"
        >
          <table class="tab-1">
            <tr>
              <td class="device-type-name">{{ item.name }}</td>
            </tr>
            <tr>
              <td class="icon">
                <span class="num" :style="getTabNumStyle(index)">{{
                  item.count
                }}</span>
              </td>
            </tr>
          </table>
        </li>
      </ul>
    </div>
    <!-- 最上层的 tab 结束 -->

    <my-divider :height="common.myDividerHeight20"></my-divider>

    <table class="container">
      <tr>
        <!-- 左侧导航栏开始 -->
        <td class="tree-menu">
          <div class="background-container" style="padding: 5px">
            <my-tree-menu
              :assets="treeMenu"
              @getActiveItem="getActiveItem"
            ></my-tree-menu>
          </div>
        </td>
        <!-- 左侧导航栏结束 -->

        <td style="width: 18px"></td>

        <!-- 中间表格部分开始 -->
        <td>
          <div>
            <el-radio-group
              v-model="tableData.stateCurrent"
              @input="stateChanged()"
            >
              <el-radio-button
                :label="tableData.summaryMap[item.name]"
                v-for="(item, index) of tableData.summary"
                :key="index"
              >
                <span>{{ tableData.summaryMap[item.name] }}</span>
                <span class="divider"></span>
                <span>{{ item.value }}</span>
              </el-radio-button>
            </el-radio-group>
            <my-divider :height="common.myDividerHeight20"></my-divider>
            <div class="container-table-data" id="divContainerTableData">
              <div
                v-for="(item, index) of tableData.deviceList"
                :key="index"
                class="list"
                @click="deviceClick(index)"
                @mouseover="deviceMouseOver(index)"
                @mouseout="deviceMouseOut()"
                :class="getDeviceListClass(index)"
              >
                <!-- 主要展示设备的名称、属性、遥测值 -->
                <table class="list">
                  <!-- 设备名称开始 -->
                  <tr>
                    <td class="device-name">
                      <el-tooltip
                        :content="item.name"
                        placement="top"
                        effect="light"
                      >
                        <span
                          class="device-name"
                          :style="getDeviceNameStyle(index)"
                          >{{ item.name }}</span
                        >
                      </el-tooltip>
                    </td>
                  </tr>
                  <!-- 设备名称结束 -->

                  <!-- 属性开始 -->
                  <tr v-for="attribute in item.attribute" :key="attribute.key">
                    <td class="attribute">
                      {{
                        getNVU(
                          attribute.name,
                          attribute.key,
                          attribute.value,
                          attribute.unit
                        )
                      }}
                    </td>
                  </tr>
                  <!-- 属性结束 -->

                  <!-- 遥测值开始 -->
                  <tr v-for="telemetry in item.telemetry" :key="telemetry.id">
                    <!-- 遥测值可以点击，stop是为了阻止事件冒泡 -->
                    <td
                      @click.stop="
                        getLightingSystemDeviceDetails(
                          telemetry.key,
                          telemetry.name,
                          item.id,
                          index
                        )
                      "
                      class="telemetry"
                      :class="getTelemetryListClass(item.id, telemetry.key)"
                    >
                      {{
                        getNVU(
                          telemetry.name,
                          telemetry.key,
                          telemetry.value,
                          telemetry.unit
                        )
                      }}
                    </td>
                  </tr>
                  <!-- 遥测值结束 -->

                  <tr v-show="showNoData(item.attribute, item.telemetry)">
                    <td>{{ noDataMsg }}</td>
                  </tr>
                </table>
              </div>
            </div>
          </div>
          <my-divider :height="common.myDividerHeight20"></my-divider>
          <div class="paging" v-if="tableData.deviceList.length > 0">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="paging.currentPage"
              :page-sizes="paging.pageSizes"
              :page-size="paging.pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="paging.total"
            >
            </el-pagination>
          </div>
        </td>
        <!-- 中间表格部分结束 -->

        <!-- 图表开始 -->
        <td class="charts">
          <div class="background-container">
            <my-title :title="deviceNameCurrent"></my-title>
            <my-divider :height="common.myDividerHeight20"></my-divider>
            <div>
              <el-date-picker
                :disabled="prevDayAvailable"
                :picker-options="pickerOptions"
                v-model="echartsData.dateCurrent"
                type="date"
                :clearable="false"
                class="date-picker"
                :format="datePickerFormat"
                :value-format="datePickerFormat"
                placeholder="选择日期"
              ></el-date-picker>
              <el-button
                @click="getAnotherDay(false)"
                :disabled="prevDayAvailable"
                >上一日</el-button
              >
              <el-button
                @click="getAnotherDay(true)"
                :disabled="nextDayAvailable"
                >下一日</el-button
              >
              <el-button
                :disabled="prevDayAvailable"
                @click="
                  getLightingSystemDeviceDetails(
                    echartsData.keyCurrent,
                    echartsData.nameCurrent,
                    echartsData.deviceIdCurrent,
                    tableData.deviceIndex
                  )
                "
              >
                查询
              </el-button>
            </div>
            <div class="download">
              <my-divider :height="common.myDividerHeight10"></my-divider>
              <el-button
                type="primary"
                plain
                v-if="authority"
                :disabled="!omitLineAvailable"
                size="small"
                icon="el-icon-download"
                style="margin-right: 20px"
                @click="exportExcel"
                >EXCEL
              </el-button>
            </div>
            <div style="height: 450px">
              <omit-line-my
                v-if="omitLineAvailable"
                :key-name="echartsData.keyCurrent"
                :id="'divCharts0'"
                :chartsData="echartsData.chartsData"
              ></omit-line-my>
              <el-empty :description="noDataMsg" v-else></el-empty>
            </div>
          </div>
        </td>
        <!-- 图表结束 -->
      </tr>
    </table>
  </div>
</template>

<script>
import { handleExportAuthority } from "@/assets/utils/handleData.js";
import TreeMenu from "@/components/zixitong/TreeMenu";
import TableCom from "@/components/zixitong/TableCom";
import MyDivider from "@/components/MyDivider";
import exportFile from "@/assets/js/xlsxFile";
import XLSX from "xlsx";
import MyTitle from "@/components/MyTitle";
import api from "@/api";
import OmitLine from "@/components/EChartsFolder/OmitLine";
import MyCustomer from "@/components/zixitong/MyCustomer";
import OmitLineMy from "@/components/EChartsFolder/OmitLineMy";
import { judgeAuthority } from "@/assets/js/utils";
import MyTreeMenu from "@/components/zixitong/MyTreeMenu";

export default {
  name: "SystemDevice",
  components: {
    MyTreeMenu,
    OmitLineMy,
    MyCustomer,
    MyTitle,
    MyDivider,
    TreeMenu,
    TableCom,
    OmitLine,
  },
  mounted() {
    this.getTabList();
    this.initDateCurrent();
  },
  data() {
    return {
      authority: false, //下载权限
      systemName: "", //进入的系统名称
      common: {
        myDividerHeight10: "10px",
        myDividerHeight20: "20px",
      },
      assetIdCurrent: "",
      deviceTypeCurrent: "",
      treeMenu: {},
      datePickerFormat: "yyyy-MM-dd",
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
        shortcuts: [
          {
            text: "今天",
            onClick(picker) {
              picker.$emit("pick", new Date());
            },
          },
          {
            text: "昨天",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24);
              picker.$emit("pick", date);
            },
          },
          {
            text: "一周前",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", date);
            },
          },
        ],
      },
      color1: "#28cccb",
      color2: "#fff",
      dateFormat: "YYYY-MM-DD",
      unitOfTime: "d",
      myChart: null,
      tabList: [], // 页面顶部的切换 tab
      tabIndex: 0,
      tabIndexHover: -1,

      /**
       * @description 英文/数字对照中文
       * @description 因为有些遥测值或属性的值是英文或数字，所以在前端展示时要对其进行转换。
       * */
      enToZhMap: [
        {
          key: "active",
          map: {
            true: "在线",
            false: "离线",
          },
        },
        {
          key: "RunSign",
          map: {
            1: "开启",
            0: "关闭",
            "-": "-",
          },
        },
      ],

      // 图表开始
      echartsData: {
        itemStyleColor: "#28cccb",
        dateCurrent: "",
        chartsData: {
          xData: [],
          yData: [],
          unit: "",
        },
        keyCurrent: "",
        nameCurrent: "",
        deviceIdCurrent: "",
      },
      // 图表结束

      // 表格开始
      tableData: {
        /**
         * @description 被排序的键名。
         * */
        sortKey: "name",
        /**
         * @description 设备列表
         * */
        deviceList: [],
        /**
         * @description 当前被点击的设备索引
         * */
        deviceIndex: 0,
        /**
         * 鼠标移入的设备索引
         * */
        deviceIndexHover: -1,
        /**
         * @description 当前被点击的设备对象
         * */
        deviceCurrent: {},
        /**
         * @description 当前被点击的设备状态。全部/在线/离线
         * */
        stateCurrent: "全部",
        /**
         * @description 状态+数量，全部 num/在线 num/离线 num
         * */
        summary: [],
        /**
         * @description 因为接口返回数据格式为[{name: "total", value: 21, unit: null}]
         * @description 所以需要将英文转换成中文
         * */
        summaryMap: {
          total: "全部",
          active: "在线",
          notActive: "离线",
        },
      },
      // 表格结束

      // 分页开始
      paging: {
        currentPage: 1,
        total: 0,
        pageSizes: [10, 20, 30],
        pageSize: 10,
      },
      // 分页结束

      noDataMsg: "暂无数据",
    };
  },
  computed: {
    /**
     *  @description 是否显示图表
     * */
    omitLineAvailable: {
      get: function () {
        return this.echartsData.chartsData.xData.length > 0;
      },
    },

    /**
     *  @description 设备状态，用于调取接口时进行传值
     *  @description "全部" => ""
     *  @description "在线" => "true"
     *  @description "离线" => "false"
     * */
    status: {
      get: function () {
        let status = "";
        const stateCurrent = this.tableData.stateCurrent;
        switch (stateCurrent) {
          case "全部":
            status = "";
            break;
          case "在线":
            status = "true";
            break;
          case "离线":
            status = "false";
            break;
          default:
            status = "";
        }

        return status;
      },
    },
    /**
     * @description 动态控制 "上一日" 按钮是否可用
     * @description 1.无设备时禁用
     * */
    prevDayAvailable: {
      get: function () {
        return this.tableData.deviceCurrent == null;
      },
    },
    /**
     * @description 动态控制 "下一日" 按钮是否可用
     * @description 1.选择的日期等于当前日期时禁用
     * @description 2.无设备时禁用
     * */
    nextDayAvailable: {
      get: function () {
        let current = this.$moment().format(this.dateFormat); // 当前日期
        let datePickerCurrent = this.echartsData.dateCurrent; // 选择的日期
        return current === datePickerCurrent
          ? true
          : this.tableData.deviceCurrent == null;
      },
    },
    /**
     * @description 当前被选择的设备名称
     * */
    deviceNameCurrent: {
      get: function () {
        let deviceCurrent = this.tableData.deviceCurrent;
        return deviceCurrent == null ? "无设备" : deviceCurrent.name;
      },
    },
  },
  methods: {
    /**
     * @description 是否显示无数据提示
     * @param {Array}attributeList 属性列表
     * @param {Array}telemetryList 遥测值列表
     * */
    showNoData(attributeList, telemetryList) {
      return attributeList.length === 0 && telemetryList.length === 0;
    },

    /**
     * @description 获取遥测值列表的样式
     * @param {String}deviceId 设备id
     * @param {String}telemetryKey 遥测值的英文名称
     * */
    getTelemetryListClass(deviceId, telemetryKey) {
      let echartsData = this.echartsData;
      return {
        "telemetry-active":
          deviceId === echartsData.deviceIdCurrent &&
          telemetryKey === echartsData.keyCurrent,
      };
    },

    /**
     * @description 获取选项卡列表的样式
     * @param {Number}index 当前选项卡的索引
     * */
    getTabListClass(index) {
      return {
        "tab-active-1": index === this.tabIndex,
        "tab-hover-1": index === this.tabIndexHover,
      };
    },

    /**
     * @description 获取选项卡设备数量的样式
     * @param {Number}index 当前选项卡的索引
     * */
    getTabNumStyle(index) {
      return { color: this.tabIndex === index ? this.color2 : this.color1 };
    },

    /**
     * @description 获取设备列表样式
     * @param {Number}deviceIndex 当前设备的索引
     * */
    getDeviceListClass(deviceIndex) {
      let tableData = this.tableData;
      return {
        "device-active": deviceIndex === tableData.deviceIndex,
        "device-hover": deviceIndex === tableData.deviceIndexHover,
      };
    },

    /**
     * @description 获取设备名称的样式
     * @param {Number}index 当前设备的索引
     * */
    getDeviceNameStyle(index) {
      return {
        color:
          index === this.tableData.deviceIndexHover &&
          index !== this.tableData.deviceIndex
            ? this.color1
            : "",
      };
    },

    /**
     * @description 生成名称，值，单位的组合格式。
     * @description N：name，V：value，U：unit。
     * @param {String} name 属性/遥测值的中文名。
     * @param {String} key 属性/遥测值的英文名。
     * @param {String} value 属性/遥测值的值。
     * @param {String} unit 属性/遥测值的单位。
     * */
    getNVU(name, key, value, unit) {
      return `${name}： ${this.transferValue(key, value)} ${unit}`;
    },

    /**
     * @description 获取项目。
     * */
    getProject() {
      return JSON.parse(window.sessionStorage.getItem("userInfo"))[
        "projects"
      ][0];
    },

    /**
     * @description 获取项目 ID。
     * */
    getProjectId() {
      return this.getProject().projectId;
    },

    /**
     * @description 获取图表。
     * @param {String} key 遥测值英文名。
     * @param {String} name 遥测值中文名。
     * @param {String} deviceId 设备 id。
     * @param {Number} deviceIndex 当前被点击的设备索引。
     * */
    async getLightingSystemDeviceDetails(key, name, deviceId, deviceIndex) {
      this.tableData.deviceIndex = deviceIndex;
      this.tableData.deviceCurrent = this.tableData.deviceList[deviceIndex];

      this.echartsData.keyCurrent = key;
      this.echartsData.nameCurrent = name;
      this.echartsData.deviceIdCurrent = deviceId;

      this.echartsData.chartsData.xData = [];
      this.echartsData.chartsData.yData = [];

      let params = {
        projectId: this.getProjectId(),
        key,
        sinicization: name,
        deviceId,
        date: this.echartsData.dateCurrent,
      };
      let res = await api.lightSystemDeviceDetails(params);

      const data = res.data.data;
      data.forEach((v) => {
        const value = v.data[0].value;
        const name = v.data[0].name;
        this.echartsData.chartsData.xData.push(
          this.$moment(parseInt(v.time)).format("HH:mm")
        );

        if (name.includes("运行时间")) {
          let va = (value / 60).toFixed(2);
          this.echartsData.chartsData.unit = va > 24 ? "天" : "H";
          this.echartsData.chartsData.yData.push(
            va > 24 ? (va / 24).toFixed(2) : va
          );
        } else {
          this.echartsData.chartsData.unit = v.unit;
          this.echartsData.chartsData.yData.push(value);
        }
      });
    },

    /**
     * @description 将服务端返回的英文或者数字转换成中文。
     * @description 如果在 enToZhMap 中能找到相对应的 key，则返回相对应的 value,否则直接返回原值 value。
     * @param {String}key 属性/遥测值英文名
     * @param {String}value 属性值/遥测值
     * */
    transferValue(key, value) {
      this.enToZhMap.forEach((val) => {
        if (key === val.key) {
          value = val.map[value];
        }
      });

      return value;
    },

    /**
     * @description 获取左侧树形菜单。
     * @param {String} deviceType 设备类型。
     * */
    async getTreeMenu(deviceType) {
      let projectId = this.getProjectId();
      let assetType = this.systemName;
      let maxLevel = 4;

      let params = { projectId, assetType, maxLevel, deviceType };
      let res = await api.lightSystemAssetsTreeMenu(params);
      this.treeMenu = res.data.assets;
    },

    /**
     * @description 获取页面顶部的 TabList（照面设备，电表等等）。
     * @description 获取 TabList 之后，再根据第一个 Tab 的 name 获取左侧菜单。
     * */
    async getTabList() {
      let projectId = this.getProjectId();
      let params = { projectId, systemType: this.systemName };
      let res = await api.lightSystemDeviceType(params);
      if (res && res.status === 200) {
        this.tabList = res.data.data;
        if (this.tabList.length === 0) {
          this.deviceTypeCurrent = "";
          await this.getTreeMenu("");
          return;
        }

        let tabFirstName = this.tabList[0].name;
        this.deviceTypeCurrent = tabFirstName;
        await this.getTreeMenu(tabFirstName);
      }
    },

    /**
     * @description 全部，在线，离线切换事件。
     * */
    stateChanged() {
      this.getDeviceList(this.assetIdCurrent);
    },

    /**
     * @description 获取 上一天/下一天。
     * @param {Boolean}next next = true，为下一天。next = false，为上一天。
     * */
    getAnotherDay(next) {
      let dateCurrent = "";

      let moment = this.$moment(this.echartsData.dateCurrent);
      let amount = 1;
      let unitOfTime = this.unitOfTime;
      let dateFormat = this.dateFormat;

      if (next) {
        dateCurrent = moment.add(amount, unitOfTime).format(dateFormat);
      } else {
        dateCurrent = moment.subtract(amount, unitOfTime).format(dateFormat);
      }

      this.echartsData.dateCurrent = dateCurrent;
      this.getLightingSystemDeviceDetails(
        this.echartsData.keyCurrent,
        this.echartsData.nameCurrent,
        this.echartsData.deviceIdCurrent,
        this.tableData.deviceIndex
      );
    },

    /**
     * @description 初始化当前日期。
     * */
    initDateCurrent() {
      this.echartsData.dateCurrent = this.$moment().format(this.dateFormat);
    },

    /**
     * @description 设备点击事件。
     * @param {Number} deviceIndex 当前被点击的设备索引。
     * */
    deviceClick(deviceIndex) {
      this.tableData.deviceIndex = deviceIndex;
      this.tableData.deviceCurrent = this.tableData.deviceList[deviceIndex];

      const deviceCurrent = this.tableData.deviceCurrent;
      const telemetryList = deviceCurrent.telemetry;
      if (telemetryList.length > 0) {
        const telemetryFirst = telemetryList[0];
        this.getLightingSystemDeviceDetails(
          telemetryFirst.key,
          telemetryFirst.name,
          deviceCurrent.id,
          deviceIndex
        );
      } else {
        // 如果遥测值列表为空，则清除图表的相关数据
        this.echartsData.chartsData = {
          xData: [],
          yData: [],
          unit: "",
        };
        this.echartsData.keyCurrent = "";
        this.echartsData.nameCurrent = "";
      }
    },

    /**
     * @description 设备鼠标移进事件。
     * @param {Number} deviceIndex 当前被移入的设备索引。
     * */
    deviceMouseOver(deviceIndex) {
      this.tableData.deviceIndexHover = deviceIndex;
    },

    /**
     * @description 设备鼠标移出事件。
     * */
    deviceMouseOut() {
      this.tableData.deviceIndexHover = -1;
    },

    /**
     * @description 排序。该方法返回排序后的数组，并对原数组进行了修改。
     * @param {Array} array 被排序的数组，样例：[{id:'',name:''}]。
     * @param {String} key 按哪个键排序，比如上面样例的 id 或者 name。
     * @param {Boolean} asc 升序还是降序。asc = true 升序，asc = false 降序
     * @return {Array} 返回排序后的数组
     * */
    sortByKey(array, key, asc) {
      return array.sort(function (a, b) {
        const x = a[key];
        const y = b[key];
        if (asc) return x < y ? -1 : x > y ? 1 : 0;

        return x > y ? -1 : x < y ? 1 : 0;
      });
    },

    /**
     * @description 设备列表。
     * @param {String} assetIdCurrent 当前被点击的资产id。
     * */
    async getDeviceList(assetIdCurrent) {
      let assetType = this.systemName;
      let projectId = this.getProjectId();
      let pageSize = this.paging.pageSize;
      let page = this.paging.currentPage - 1;
      let status = this.status;
      let deviceType = this.deviceTypeCurrent;

      let params = {
        projectId,
        pageSize,
        page,
        assetType,
        assetId: assetIdCurrent,
        status,
        deviceType,
      };

      let res = await api.lightSystemDevicePage(params);
      if (res && res.status === 200) {
        let sortKey = this.tableData.sortKey;
        let newArrMap = res.data.data.page.data;
        newArrMap.map((item) => {
          item.telemetry.map((v) => {
            if (v.value != "-" && v.name.includes("运行时间")) {
              let va = (v.value / 60).toFixed(2);
              v.value = va > 24 ? (va / 24).toFixed(2) : va;
              v.unit = va > 24 ? "天" : "H";
            }
          });
        });

        this.tableData.deviceList = newArrMap;

        this.sortByKey(this.tableData.deviceList, sortKey, true); // 按设备名称排序（升序）
        this.tableData.deviceList.forEach((val) => {
          this.sortByKey(val.telemetry, sortKey, true); // 按每个设备的遥测值名称排序（升序）
        });
        this.tableData.summary = res.data.data["statistics"];

        this.paging.total = res.data.data.page["totalElements"];

        const deviceList = this.tableData.deviceList;

        if (deviceList.length === 0) {
          this.echartsData.chartsData.xData = [];
          this.echartsData.chartsData.yData = [];
          this.tableData.deviceCurrent = null;

          return;
        }

        const deviceFirst = deviceList[0];
        this.tableData.deviceCurrent = deviceFirst;
        const telemetryList = deviceFirst["telemetry"];
        if (telemetryList.length > 0) {
          const telemetryFirst = telemetryList[0];
          await this.getLightingSystemDeviceDetails(
            telemetryFirst.key,
            telemetryFirst.name,
            deviceFirst.id,
            0
          );
        }
      }
    },

    /**
     * @description 导出 EXCEL。
     * */
    exportExcel() {
      let th = ["时间"];
      th.push(
        `${this.tableData.deviceCurrent.name}-${this.echartsData.nameCurrent}(${this.echartsData.chartsData.unit})`
      );
      // 内容区
      let content = [];
      for (let i = 0; i < this.echartsData.chartsData.yData.length; i++) {
        let row = [];
        row.push(this.echartsData.chartsData.yData[i]);
        row.unshift(
          this.echartsData.dateCurrent +
            " " +
            this.echartsData.chartsData.xData[i]
        );
        content.push(row);
      }
      exportFile.xlsxFile(
        XLSX,
        `${this.tableData.deviceCurrent.name}-${this.echartsData.nameCurrent}-${this.echartsData.dateCurrent}`,
        {
          excel: [th, ...content],
        }
      );
    },

    /**
     * @description 页面大小改变事件。
     * @param val 当前被选择的页面大小值。
     * */
    handleSizeChange(val) {
      this.paging.pageSize = val;
      this.getDeviceList(this.assetIdCurrent);
    },

    /**
     * @description 页码点击事件。
     * @param val 当前被点击的页码数。
     * */
    handleCurrentChange(val) {
      this.paging.currentPage = val;
      this.getDeviceList(this.assetIdCurrent);
    },

    /**
     * @description 左侧导航栏点击事件。
     * @param {Object} data 子组件携带过来的数据，包含当前点击资产的id，name等。
     * */
    async getActiveItem(data) {
      this.assetIdCurrent = data.id;
      await this.getDeviceList(this.assetIdCurrent);
    },

    /**
     * @description 最上层的 tab 点击事件。
     * @param {Number} index 当前被点击的 tab 索引。
     * @param {String} deviceType 设备类型。
     * */
    async tabChange(index, deviceType) {
      this.tabIndex = index;
      this.deviceTypeCurrent = deviceType;

      await this.getTreeMenu(deviceType);
    },

    /**
     * @description 最上层的 tab - 鼠标移入事件。
     * @param {Number} index 当前 tab 的索引。
     * */
    tabMouseOver(index) {
      if (this.tabIndex === this.tabIndexHover) {
      } else {
        this.tabIndexHover = index;
      }
    },

    /**
     * @description 最上层的 tab - 鼠标移出事件。
     * */
    tabMouseOut() {
      this.tabIndexHover = -1;
    },
  },
  created() {
    this.authority = judgeAuthority(handleExportAuthority(this.$route.path));
    this.systemName =
      this.$route.path === "/systemDevice"
        ? "照明系统"
        : this.$route.path === "/dynamicalDevice"
        ? "动力系统"
        : "";
  },
};
</script>

<style scoped lang="scss">
$color1: #28cccb;
$color2: #fff;
$borderRadius: 6px;

table {
  width: 100%;
}

/*定义滚动条轨道*/
#divContainerTableData::-webkit-scrollbar-track {
  background-color: #f7f7f7;
  -webkit-box-shadow: inset 0 0 0px #f7f7f7;
}

/*定义滚动条高宽及背景*/
#divContainerTableData::-webkit-scrollbar {
  background-color: #f7f7f7;
}

/*定义滚动条*/
#divContainerTableData::-webkit-scrollbar-thumb {
  background-color: #f7f7f7;
}

#divContainerTableData:hover::-webkit-scrollbar-thumb {
  background-color: #dddddd;
}

td.attribute {
  padding-left: 10px;
  padding-right: 10px;
}

td.telemetry {
  padding-left: 10px;
  padding-right: 10px;
}

td.telemetry-active {
  background-color: $color1;
  color: $color2;
}

td.telemetry:hover {
  background-color: $color1;
  color: $color2;
}

div.container-table-data {
  height: 570px;
  overflow: scroll;
}

div.container-table-data:hover {
  overflow: scroll;
  overflow-x: unset;
}

div.empty {
  margin-top: 0;
  height: 600px;
}

table.tab-1 {
  width: 90%;
  height: 50%;
  text-align: center;
  padding: 5px;

  img {
    width: 26px;
  }

  td {
    vertical-align: top;
  }
}

.date-picker {
  width: 37%;
  margin-right: 10px;
}

td.progress {
  width: 65%;
}

span.num {
  font-size: 36px;
}

span.divider {
  display: inline-block;
  width: 5px;
}

span.state {
  color: $color1;
}

span.state:hover {
  color: $color2;
}

span.device-name {
  display: inline-block;
  overflow: hidden;
  height: 20px;
}

td.device-name {
  font-size: 1.3em;
  font-weight: bold;
  overflow: hidden;
  text-align: center;
}

td.device-type-name {
  width: 60%;
  font-size: 0.9em;
  padding-top: 6px;
}

div.background-container {
  background-color: $color2;
  border-radius: $borderRadius;
  padding: 15px;
  height: 600px;
}

div.download {
  text-align: right;
}

h3.title {
  border-left: 5px solid $color1;
  padding-left: 10px;
}

td.charts {
  width: 32%;
  vertical-align: top;
}

div.charts {
  width: 100%;
  height: 400px;
}

div.paging {
  text-align: center;
}

table.list {
  font-size: 0.9em;
  width: 170px;

  tr {
    height: 25px;
  }
}

div.list {
  display: inline-block;
  background-color: $color2;
  border-radius: $borderRadius;
  margin-right: 17px;
  margin-bottom: 15px;
  font-size: 0.9em;
  text-align: left;
  border: 1px solid $color2;
  padding: 5px 0;
}

td.tree-menu {
  width: 20%;
  vertical-align: top;
}

div.divider {
  height: 30px;
}

table.container {
  width: 100%;
}

div.container1 {
  width: 98%;
  padding: 1%;
  flex-direction: column;
  justify-content: space-between;
}

div.tab-list {
  height: 10%;
}

ul.tab-list {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

li.tab {
  width: 10%;
  margin-right: 1.6%;
  height: 100%;
  background: $color2;
  border: 1px solid $color2;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: $borderRadius;
}

li.tab-1 {
  width: 10%;
  margin-right: 1.6%;
  height: 100%;
  background: $color2;
  border: 1px solid $color2;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: $borderRadius;
  padding-left: 5px;
  padding-top: 0;
  padding-right: 5px;
}

td.icon {
  text-align: center;
}

li.tab-hover {
  border: 1px solid $color1;
  color: $color1;
  cursor: pointer;
}

li.tab-hover-1 {
  border: 1px solid $color1;
  color: $color1;
  cursor: pointer;
}

div.device-active {
  cursor: pointer;
  border: 1px solid $color1;
}

div.device-hover {
  border: 1px solid $color1;
  cursor: pointer;
}

li.tab-active {
  background-color: $color1;
  color: $color2;
  border: 1px solid $color2;
}

li.tab-active-1 {
  background-color: $color1;
  color: $color2;
  border: 1px solid $color2;
}
</style>
